import React from "react";
import { useLang } from "@/context/LanguageContext";

export const CATEGORY_LABELS = {
  FIN_UPI: { en: "UPI / Payment Fraud", hi: "यूपीआई / भुगतान धोखाधड़ी" },
  FIN_INV: { en: "Investment / Trading Scam", hi: "निवेश / ट्रेडिंग घोटाला" },
  FIN_ARREST: { en: "Digital Arrest Scam", hi: "डिजिटल अरेस्ट घोटाला" },
  FIN_OTP: { en: "OTP / KYC Fraud", hi: "ओटीपी / केवाईसी धोखाधड़ी" },
  FIN_JOB: { en: "Job / Task Fraud", hi: "नौकरी / टास्क धोखाधड़ी" },
  FIN_LOAN: { en: "Loan App Harassment", hi: "लोन ऐप उत्पीड़न" },
  FIN_ROMANCE: { en: "Matrimonial / Romance Scam", hi: "वैवाहिक / रोमांस घोटाला" },
  FIN_TECH: { en: "Tech Support / Remote Access", hi: "तकनीकी सहायता / रिमोट एक्सेस" },
  FIN_PHISH: { en: "Phishing", hi: "फ़िशिंग" },
  FIN_ECOM: { en: "E-Commerce / Shopping Fraud", hi: "ई-कॉमर्स / शॉपिंग धोखाधड़ी" },
  FIN_AEPS: { en: "AEPS / Biometric Fraud", hi: "एईपीएस / बायोमेट्रिक धोखाधड़ी" },
  FIN_SIM: { en: "SIM Swap Fraud", hi: "सिम स्वैप धोखाधड़ी" },
  FIN_CRYPTO: { en: "Cryptocurrency Fraud", hi: "क्रिप्टोकरेंसी धोखाधड़ी" },
  FIN_COURIER: { en: "Courier / Parcel Scam", hi: "कूरियर / पार्सल घोटाला" },
  FIN_GAMING: { en: "Online Gaming Fraud", hi: "ऑनलाइन गेमिंग धोखाधड़ी" },
  CA_RANSOM: { en: "Ransomware Attack", hi: "रैंसमवेयर हमला" },
  OTH_SMHACK: { en: "Social Media Account Hacking", hi: "सोशल मीडिया खाता हैकिंग" },
  OTH_BEC: { en: "Business Email Compromise", hi: "व्यावसायिक ईमेल समझौता" },
  WOM_SEXT: { en: "Sextortion", hi: "सेक्सटॉर्शन" },
  SOC_IMPER: { en: "Social Media Impersonation", hi: "सोशल मीडिया प्रतिरूपण" },
  OTHER: { en: "Other", hi: "अन्य" },
};

export function useCategoryLabel() {
  const { lang } = useLang();
  return (code) => (CATEGORY_LABELS[code] ? CATEGORY_LABELS[code][lang] : code);
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between mb-8">
      <div>
        <h1 className="font-head text-2xl font-bold text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1 text-sm">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

const DIFF_STYLES = {
  easy: "bg-emerald-50 text-emerald-700 border-emerald-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  hard: "bg-red-50 text-red-700 border-red-200",
};

export function DifficultyBadge({ level }) {
  const { t } = useLang();
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${DIFF_STYLES[level] || DIFF_STYLES.easy}`}>
      {t(level)}
    </span>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`bg-white rounded-lg border border-slate-200 shadow-sm p-6 ${className}`} {...rest}>
      {children}
    </div>
  );
}

export const ACCENT_HEX = {
  amber: "#D97706", green: "#059669", blue: "#2563EB", purple: "#7C3AED", red: "#DC2626",
};
export const CHART_COLORS = ["#2563EB", "#059669", "#D97706", "#7C3AED", "#DC2626", "#0891B2", "#DB2777", "#65A30D"];
